// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2RZ36","loaderOuter":"PageOverlayLoader_loaderOuter__33LDe"};